import { Check } from "lucide-react";
import { useStateValue } from "../../context/StateProvider";
export default function Stepper({ steps, currentStep, onStepClick }) {
  const [{ user }, dispatch] = useStateValue();

  return (
    <div className="w-full">
      {/* Desktop View */}
      <div className="hidden sm:block">
        <div className="flex items-center justify-center">
          {steps.map(
            (step, index) =>
              step.access.includes(user.role) && (
                <div
                  key={step.number}
                  className="flex items-center justify-center w-full relative"
                >
                  {/* Step Circle */}
                  <button
                    onClick={() => onStepClick(step.number)}
                    className={`w-12 h-12 rounded-full flex items-center justify-center font-semibold text-sm transition-all relative z-10 ${
                      currentStep > step.number
                        ? "bg-[#1E293B] text-white"
                        : currentStep === step.number
                          ? "bg-gray-100 text-black ring-4 ring-primary/30"
                          : "bg-gray-100 text-black border-2 border-border"
                    }`}
                  >
                    {currentStep > step.number ? (
                      <Check className="w-6 h-6" />
                    ) : (
                      step.number
                    )}
                  </button>

                  {/* Connector Line */}
                  {(((user.role == "Admin" || user.role == "Supervisor" || user.role == "Accountant") &&
                    index < steps.length - 1) ||
                    (user.role == "Employee" && index < steps.length - 3)) && (
                    <div
                      className={`absolute left-1/2 top-1/2 w-full h-1 mx-2 rounded-full transition-colors ${
                        currentStep > step.number
                          ? "bg-[#1E293B]"
                          : "bg-gray-200"
                      }`}
                    />
                  )}
                </div>
              ),
          )}
        </div>

        {/* Step Labels */}
        <div className="flex justify-between mt-4">
          {steps.map(
            (step) =>
              step.access.includes(user.role) && (
                <div key={step.number} className="flex-1 text-center">
                  <p className="font-semibold text-foreground text-sm">
                    {step.title}
                  </p>
                  {/* <p className="text-xs text-muted-foreground mt-1">
                {step.description}
              </p> */}
                </div>
              ),
          )}
        </div>
      </div>

      {/* Mobile View */}
      <div className="sm:hidden">
        <div className="space-y-3">
          {steps.map(
            (step, index) =>
              step.access.includes(user.role) && (
                <div key={step.number}>
                  <button
                    onClick={() => onStepClick(step.number)}
                    className="w-full flex items-center gap-4 p-4 rounded-lg border transition-all"
                    style={{
                      borderColor:
                        currentStep >= step.number ? "#4F46E5" : "#D1D5DB",
                      backgroundColor:
                        currentStep === step.number
                          ? "#1A2437"
                          : currentStep > step.number
                            ? "#4F46E5"
                            : "transparent",
                    }}
                  >
                    <div
                      className="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center font-semibold text-sm"
                      style={{
                        backgroundColor:
                          currentStep === step.number
                            ? "#4F46E5"
                            : currentStep === step.number
                              ? "#D1D5DB"
                              : "#F3F4F6",
                        color:
                          currentStep === step.number
                            ? "#ffff"
                            : currentStep === step.number
                              ? "#4F46E5"
                              : "black",
                      }}
                    >
                      {currentStep > step.number ? (
                        <Check className="w-5 h-5" />
                      ) : (
                        step.number
                      )}
                    </div>
                    <div className="text-left">
                      <p
                        className="font-semibold text-sm text-white"
                        style={{
                          color:
                            currentStep === step.number
                              ? "white"
                              : currentStep > step.number
                                ? "white"
                                : "black",
                        }}
                      >
                        {step.title}
                      </p>
                    </div>
                  </button>

                  {/* Mobile Connector */}
                  {index < steps.length - 1 && (
                    <div
                      className="h-2 mx-5 rounded-full"
                      style={{
                        backgroundColor:
                          currentStep > step.number
                            ? "var(--primary)"
                            : "var(--border)",
                      }}
                    />
                  )}
                </div>
              ),
          )}
        </div>
      </div>
    </div>
  );
}
